import { Box, Stack, Typography, Divider } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

const items = [
  {
    icon: <AccessTimeIcon sx={{ fontSize: { xs: 28, md: 36, lg: 48 } }} />,
    title: 'Working Hours',
    line1: 'Mon - Sat 09:00AM - 05:30PM',
  },
  {
    icon: <EmailOutlinedIcon sx={{ fontSize: { xs: 28, md: 36, lg: 48 } }} />,
    title: 'Email Now!',
    line1: 'contact@citycourier.pk',
  },
//   {
//     icon: <PhoneInTalkOutlinedIcon sx={{ fontSize: 48 }} />,
//     title: 'Get In Touch',
//     line1: '(042) 35700000',
//   },
];

const InfoBarSection = () => (
  <Box sx={{ bgcolor: 'secondary.main', color: 'white', py: { xs: 3, md: 0 }, px: 0 }}>
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      divider={
        <Divider
          orientation="vertical"
          flexItem
          sx={{ borderColor: 'rgba(255,255,255,0.25)', display: { xs: 'none', md: 'block' } }}
        />
      }
      spacing={0}
      alignItems="center"
      justifyContent="center"
      sx={{ maxWidth: '1200px', mx: 'auto', minHeight: 100 }}
    >
      {items.map((item, idx) => (
        <Box
          key={item.title}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            py: { xs: 2, md: 0 },
            px: { xs: 2, md: 6 },
            width: { xs: '100%', md: 'auto' },
            justifyContent: { xs: 'flex-start', md: 'center' },
          }}
        >
          {item.icon}
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: { xs: 14, md: 16, lg: 18 } }}>
              {item.title}
            </Typography>
            <Typography variant="body1" sx={{ fontSize: { xs: 12, md: 14, lg: 16 }, opacity: 0.95 }}>
              {item.line1}
            </Typography>
          </Box>
        </Box>
      ))}
    </Stack>
  </Box>
);

export default InfoBarSection; 